import { render, staticRenderFns } from "./SuperAdminAppointments.vue?vue&type=template&id=3fecae18&scoped=true&"
import script from "./SuperAdminAppointments.vue?vue&type=script&lang=js&"
export * from "./SuperAdminAppointments.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminAppointments.vue?vue&type=style&index=0&id=3fecae18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fecae18",
  null
  
)

export default component.exports